<nalco-loader *ngIf="showLoader" [loader]="true"></nalco-loader>

<div *ngIf="!showLoader" class="container py-5">
	<div class="row justify-content-center">
		<div class="col-md-8 col-lg-6">
			<div class="alert alert-info text-center mb-0">
				<h4 class="mb-3">Session ended</h4>
				<p class="mb-3">
					This tab was signed out because the session ended in another tab.
				</p>
				<button type="button" class="btn btn-primary" (click)="signInAgain()">
					Sign in again
				</button>
			</div>
		</div>
	</div>
</div>